import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useQueryParams = () => {
  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();
  const [token, setToken] = useState('');
  const [supplier_id, setSupplierId] = useState('');
  const [role, setRole] = useState('');
  const [falconBusinessType, setFalconBusinessType] = useState('');
  const [sellerName, setSellerName] = useState('');

  useEffect(() => {
    const token = query.get('token'),
      supplier_id = query.get('supplier_id'),
      role = query.get('role'),
      falconBusinessType = query.get('falconBusinessType'),
      sellerName = query.get('sellerName');
    if (token && supplier_id && role && falconBusinessType) {
      setToken(token);
      setSupplierId(supplier_id);
      setRole(role);
      setFalconBusinessType(falconBusinessType);
      setSellerName(sellerName || '');
    }
  }, [query]);

  return {
    token,
    supplier_id,
    role,
    falconBusinessType,
    sellerName,
  };
};

export default useQueryParams;
